<template>
  <div class="file_choose_box">
    <div class="icon">
      <el-icon>
        <Document />
      </el-icon>
    </div>
    <div class="input_box">
      <template v-if="data.filePaths.length == 0">
        <div class="upload_box pointer" @click="choosefile" @dragover="dragover" @drop="drop">
          <div class="icon marginAuto"><el-icon size="50px" color="#a8abb2">
              <Document />
            </el-icon></div>
          <!-- <div class="title marginAuto">将文件拖到此处，或者<em>点击选择</em></div> -->
          <div class="title marginAuto"><em>点击选择</em></div>
          <div class="desc marginAuto textCenter">请将不需要区分发送学员的文件(非个性化文件)添加到此处</div>
        </div>
        <input type="file" ref="file" multiple webkitdirectory style="display:none" @change="inputChange">
      </template>
      <template v-else>
        <ul class="file_name_list folder_file_box">
          <li class="list_item" v-for="(item, index) in data.filePaths" :key='index'>
            <fileCard :file-data="item"></fileCard>
          </li>
        </ul>
      </template>
    </div>

  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { pickFiles } from '@/utils/callingAppApi'
import fileCard from '@/components/fileCard.vue'
let chooseing = false;
const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const file = ref()

const choosefile = () => {
  if (chooseing) return;
  chooseing = true;
  // file.value.click()
  pickFiles((paths) => {
    chooseing = false;
    if (paths.length == 0) return;
    props.data.filePaths = paths.map(p => {
      return {
        path: p
      }
    })
  })
};
const dragover = (e) => {
  e.preventDefault();
  e.stopPropagation()
};
const drop = (e) => {
  e.preventDefault();
  e.stopPropagation()
  // console.log(e)
  // console.log('drop-----', e.dataTransfer.files)
};
const inputChange = (e) => {
  console.log('inputChange-----', e.target.files)
  console.dir(e.target)
  let files = e.target.files;
  // console.log(window.URL.createObjectURL(files[0]));
  console.log(file.value.value);
  console.log(files.item(0))
  // for(let i = 0 ; i < files.length; i++){
  //   let file = files[i];
  //   fil
  //   // let reader = new FileReader();
  //   // reader.onload = ()=>{
  //   //   console.log('文件绝对路径：',reader)
  //   // }
  //   // reader.readAsDataURL(file)
  // }
}
</script>

<style lang="less" scoped>
.file_choose_box {
  display: flex;
  align-items: center;

  .icon {
    width: 50px;
    text-align: center;
  }

  .input_box {
    flex: auto;
    border: 1px solid #ccc;
    padding: 10px;

    .file_name_list {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      .list_item {
        margin: 5px 0;
        // width: 95%;
        font-size: 14px;
        padding: 5px 10px;
        // background: #fff;
        line-height: 40px;
        white-space: pre-wrap;
      }
    }
  }
}
</style>